export { Text } from './Text/Text';
export { Heading } from './Heading/Heading';
export { GradientText, } from './GradientText/GradientText';
export { Label } from './Label/Label';
//# sourceMappingURL=index.js.map